function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        "\n        ",
        "\n        ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { baseButtonStyles, buttonSizeStyles, buttonTransitionStyles, TextContainer } from "./Button";
import styled, { css } from "styled-components";
var ButtonLink = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var className = props.className, variant = props.variant, text = props.text, iconLeft = props.iconLeft, iconRight = props.iconRight, disabled = props.disabled, fill = props.fill, size = props.size, onClick = props.onClick, linkBtnProps = _objectWithoutProperties(props, [
        "className",
        "variant",
        "text",
        "iconLeft",
        "iconRight",
        "disabled",
        "fill",
        "size",
        "onClick"
    ]);
    return /*#__PURE__*/ _jsxs(StyledButtonLink, _objectSpread({
        ref: ref,
        className: className,
        variant: variant,
        disabled: disabled,
        onClick: function(e) {
            if (!disabled) {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
            }
        },
        $fill: fill,
        size: size
    }, linkBtnProps, {
        children: [
            iconLeft,
            /*#__PURE__*/ _jsx(TextContainer, {
                children: text
            }),
            iconRight
        ]
    }));
});
export { ButtonLink };
export var StyledButtonLink = styled.a.withConfig({
    componentId: "sc-324fa24b-0"
})(_templateObject1(), function(param) {
    var $fill = param.$fill, variant = param.variant, disabled = param.disabled, size = param.size;
    return css(_templateObject(), baseButtonStyles({
        variant: variant,
        fill: $fill,
        disabled: disabled
    }), buttonSizeStyles(size), buttonTransitionStyles);
});
